export const TYPES = [
  { label: "number", value: "number" },
  { label: "text", value: "text" },
  { label: "date", value: "date" },
];

export const COMPARATORS = [
  { label: "equals", value: "equals", validResponseType: ["number", "text"] },
  {
    label: "not equals",
    value: "notEquals",
    validResponseType: ["number", "text"],
  },
  {
    label: "between",
    value: "between",
    validResponseType: ["number", "date"],
  },
  {
    label: "minimum",
    value: "min",
    validResponseType: ["number", "date"],
  },
  {
    label: "maximum",
    value: "max",
    validResponseType: ["number", "date"],
  },
  { label: "one of", value: "oneOf", validResponseType: ["number", "text"] },
];
